const rawBaseURL = process.env.REACT_APP_API_BASE_URL || undefined;
const rawApiKey = process.env.REACT_APP_API_KEY;

// In the mobile WebView build, REACT_APP_API_BASE_URL and REACT_APP_API_KEY are
// intentionally not set at build time — the mobile app injects them at runtime via
// localStorage ClusterConfig. Skip the strict check to avoid crashing the WebView.
const isMobileBuild = process.env.REACT_APP_WEBVIEW_MODE_ENABLED === 'true';

if (!rawBaseURL && !isMobileBuild) {
  throw new Error('Missing REACT_APP_API_BASE_URL');
}

if (!rawApiKey && !isMobileBuild) {
  throw new Error('Missing REACT_APP_API_KEY');
}

export const apiBaseUrl: string = rawBaseURL ?? '';
export const apiKey: string = rawApiKey ?? '';
